const balances = [
    {
        "account_id": "c49a5169-bf6e-4776-8d86-00badf3f482e",
        "balance": 15035.85,
        "currency_code": "AED",
        "account_name": "Beyond Current Account",
        "account_type": "CURRENT"
    }, {
        "account_id": "31e9387c-2815-4a70-98b4-5bf140d1136e",
        "balance": 50392.85,
        "currency_code": "AED",
        "account_name": "Smart Saver Account",
        "account_type": "SAVINGS"
    }, {
        "account_id": "a33d9e07-5d24-4491-a29b-07915b0f066f",
        "balance": 16890.23,
        "currency_code": "USD",
        "account_name": "Easy Max Saver",
        "account_type": "SAVINGS"
    }, {
        "account_id": "031c226f-5510-4d17-9bc3-3275b51f5b44",
        "balance": -193584.67,
        "currency_code": "AED",
        "account_name": "FAB Infinite Credit Card",
        "account_type": "CREDIT"
    }
]

export default balances